import { library } from "@fortawesome/fontawesome-svg-core";
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import {
    faAddressBook,
    faBan,
    faBuilding,
    faClockRotateLeft,
    faScaleUnbalanced,
    faScaleUnbalancedFlip,
    faCopy as solidfaCopy
} from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { OidcProvider, loadUser } from 'redux-oidc';
import "tabulator-tables/dist/css/tabulator.min.css";
import App from './App';
import { store } from './redux/store';
import * as serviceWorker from './registerServiceWorker';
import './resources/bootstrap-icons-1.11.3/font/bootstrap-icons.css';
import userManager from "./utils/userManager";
import FusionCharts from 'fusioncharts';
import Charts from 'fusioncharts/fusioncharts.charts';
import ReactFC from 'react-fusioncharts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import ReactGA from "react-ga4";

const licenseKey = process.env.REACT_APP_FUSIONCHARTS_LICENSE_KEY;

if (licenseKey) {
    FusionCharts.options.license({
        key: licenseKey,
        creditLabel: false,
    });
}


// 1. Initialize the FusionCharts React wrapper
ReactFC.fcRoot(FusionCharts, Charts, FusionTheme);

ReactGA.initialize("G-H2PHQMHC4X");

ReactDOM.render(

    <Provider store={store}>
        <OidcProvider userManager={userManager} store={store}>
            <App />
        </OidcProvider>
    </Provider>,

    document.getElementById('root'));

serviceWorker.unregister();
loadUser(store, userManager);
library.add(faScaleUnbalancedFlip, faScaleUnbalanced, faBan,
    faClockRotateLeft, faBuilding, faAddressBook, solidfaCopy, faCopy);                 